<script lang="ts" setup>
import { ref } from 'vue';
import { getRegistrationUrl } from '../utils/registration';
defineOptions({
  name: 'FooterPop',
});

const isShow = ref(true);

const handlleClose = () => {
  isShow.value = false;
}

const joinCommunity = async () => {
  window.open(getRegistrationUrl(), '_blank')
};
</script>

<template>
  <div>
    <div class="fixed bottom-8px left-0 right-0 z-999 mx-9px h-40px items-center justify-between rounded-4px bg-#3D7CFA px-12px opacity-94 shadow-[0_0_8px_0_rgba(0,0,0,0.1)] flex!" v-if="isShow">
      <div class="flex items-center">
        <img src="../assets/images/icons/popup-close.png" alt="Close" class="mr-12px h-18px w-18px cursor-pointer" @click="handlleClose">
        <div class="max-w-280px truncate text-14px text-white font-500 leading-20px">更多精彩内容，请前往会场了解！</div>
      </div>
      <button type="button" class="h-24px border border-white rounded-full bg-transparent px-12px text-12px text-white font-400 transition-colors hover:bg-white hover:text-#3D7CFA" @click="joinCommunity">立即报名</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
